import { DefaultEffects, IImageStyleProps, IImageStyles, IStyleFunctionOrObject, keyframes, mergeStyles, MotionAnimations, MotionDurations } from "@fluentui/react";

export const containerStyles = mergeStyles([{
    width: '100%',
    height: '100%',
    gap: '1dvh'
}]);

export const profileBoxContainerStyles = mergeStyles([{
    width: '100%',
    height: '21dvh'
}]);

export const actionParentContainerStyles = mergeStyles([{
    width: '100%',
    height: '78dvh'
}]);

export const mdActionsParentContainerStyles = mergeStyles([{
    width: '100%',
    height: '78dvh',

    padding: '2dvh'
}]);

export const smAtionsParentContainerStyles = mergeStyles([{
    width: '100%',
    height: '78dvh',

    padding: '2dvh'
}]);

export const onlyActionsContainerStyles = mergeStyles([{
    width: '100%',
    height: '80%',
    //overflowY: 'auto'
}]);

export const actionsContainerStyles = mergeStyles([{
    width: '100%',
    height: '98%',
    //overflowY: 'auto'
}]);

export const leftContainerStyles = mergeStyles([{
    height: '100%',
    width: '65%'
}]);

export const onlyLeftContainerStyles = mergeStyles([{
    height: '100%',
    width: '100%'
}]);

export const rightContainerStyles = mergeStyles([{
    height: '100%',
    width: '30%',
    boxShadow: DefaultEffects.elevation16,
    backgroundColor: '#F8FAFF',
    borderRadius: '10px'
}]);

export const chatContainerStyles = mergeStyles([{
    margin: "25px",
    height: "100%",
    gap: "20px"
}]);

export const chatInnerContainerStyles = mergeStyles([{
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    height: '100%',
    maxHeight: 'calc(98.25dvh - 120px)',
    width: "100%",
    maxWidth: "100%",
    margin: '0 auto',
    fontFamily: "Nunito",
}]);

//#region Dashboard buttons

export const buttonRowStyles = mergeStyles([{
    marginBottom: '0.5rem',
    gap: '0.5rem',
    display: 'grid',
    textAlign: 'center',
    gridTemplateColumns: 'repeat(12, 1fr)',
    alignContent: 'center'
}]);

export const buttonRowContainerStyles = mergeStyles([{
    gap: '4dvh',
}]);

//#region NORMAL

export const buttonContainerStyles = mergeStyles([{
    width: '100%',
    padding: '1dvh',
    backgroundColor: '#F0F0F0',
    cursor: 'pointer',
    borderRadius: '5px',
    border: '1px solid #323130',
    boxShadow: '-2px 1px 4px -1px rgba(110,110,110,0.54)',
    animation: MotionAnimations.fadeIn,
    animationDuration: MotionDurations.duration4,
    ':hover': {
        width: '100%',
        padding: '1dvh',
        backgroundColor:'rgba(42, 125, 225, 0.2)',
        cursor: 'pointer',
        borderRadius: '5px',
        border: '1px solid rgb(42, 125, 225)'
    }
}]);

export const iconStyles = mergeStyles([{
    fontSize: '2rem',
    color: '#a9c963'
}]);

export const xxlIconStyles = mergeStyles([{
    fontSize: '1.75rem',
    color: '#a9c963'
}]);

export const xlIconStyles = mergeStyles([{
    fontSize: '1.5rem',
    color: '#a9c963'
}]);

export const lgIconStyles = mergeStyles([{
    fontSize: '1.25rem',
    color: '#a9c963'
}]);

export const mdIconStyles = mergeStyles([{
    fontSize: '1rem',
    color: '#a9c963'
}]);

export const smIconStyles = mergeStyles([{
    fontSize: '0.75rem',
    color: '#a9c963'
}]);

export const imgIconStyles: IStyleFunctionOrObject<IImageStyleProps, IImageStyles> = {
    image: {
        width: '3rem',
        height: '3rem',
        color: '#a9c963'
    }
};

export const xxlImgIconStyles: IStyleFunctionOrObject<IImageStyleProps, IImageStyles> = {
    image: {
        width: '3rem',
        height: 'auto',
        color: '#a9c963'
    }
};

export const xlImgIconStyles: IStyleFunctionOrObject<IImageStyleProps, IImageStyles> = {
    image: {
        width: '1.5rem',
        height: 'auto',
        color: '#a9c963'
    }
};

export const lgImgIconStyles: IStyleFunctionOrObject<IImageStyleProps, IImageStyles> = {
    image: {
        width: '1.25rem',
        height: 'auto',
        color: '#a9c963'
    }
};

export const mdImgIconStyles: IStyleFunctionOrObject<IImageStyleProps, IImageStyles> = {
    image: {
        width: '1rem',
        height: 'auto',
        color: '#a9c963'
    }
};

export const smImgIconStyles: IStyleFunctionOrObject<IImageStyleProps, IImageStyles> = {
    image: {
        width: '0.75rem',
        height: 'auto',
        color: '#a9c963'
    }
};

export const buttonTextContainerStyles = mergeStyles([{
    gap: '0.4dvh',
}]);

export const buttonTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const xxlButtonTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1rem, 2.5vw, 1rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const xlButtonTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.5vw, 0.9rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const lgButtonTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.85rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const mdButtonTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.8rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const smButtonTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.75rem, 2.5vw, 0.75rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const buttonSubtitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const xxlButtonSubtitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const xlButtonSubtitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const lgButtonSubtitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const mdButtonSubtitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

export const smButtonSubtitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.875rem)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'left'
}]);

//#endregion NORMAL

//#region DISABLED

export const buttonContainerDisabledStyles = mergeStyles([{
    width: '100%',
    padding: '1dvh',
    backgroundColor: '#F0F0F0',
    cursor: 'pointer',
    borderRadius: '5px',
    animation: MotionAnimations.fadeIn,
    animationDuration: MotionDurations.duration4
}]);

export const iconDisabledStyles = mergeStyles([{
    fontSize: '2rem',
    color: '#909090',
}]);

export const xxlIconDisabledStyles = mergeStyles([{
    fontSize: '1.75rem',
    color: '#909090',
}]);

export const xlIconDisabledStyles = mergeStyles([{
    fontSize: '1.5rem',
    color: '#909090',
}]);

export const lgIconDisabledStyles = mergeStyles([{
    fontSize: '1.25rem',
    color: '#909090',
}]);

export const mdIconDisabledStyles = mergeStyles([{
    fontSize: '1rem',
    color: '#909090',
}]);

export const smIconDisabledStyles = mergeStyles([{
    fontSize: '0.75rem',
    color: '#909090',
}]);

export const buttonDisabledTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
    fontWeight: 600,
    color: '#909090',

    textAlign: 'left'
}]);

export const xxlButtonDisabledTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1rem, 2.5vw, 1rem)',
    fontWeight: 600,
    color: '#909090',

    textAlign: 'left'
}]);

export const xlButtonDisabledTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.5vw, 0.9rem)',
    fontWeight: 600,
    color: '#909090',

    textAlign: 'left'
}]);

export const lgButtonDisabledTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.85rem)',
    fontWeight: 600,
    color: '#909090',
    
    textAlign: 'left'
}]);

export const mdButtonDisabledTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.8rem)',
    fontWeight: 600,
    color: '#909090',

    textAlign: 'left'
}]);

export const smButtonDisabledTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.75rem, 2.5vw, 0.75rem)',
    fontWeight: 600,
    color: '#909090',

    textAlign: 'left'
}]);

export const buttonDisabledSubtitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
    fontWeight: 300,
    color: '#909090',

    textAlign: 'left'
}]);

export const xxlButtonDisabledSubtitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 300,
    color: '#909090',

    textAlign: 'left'
}]);

export const xlButtonDisabledSubtitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 300,
    color: '#909090',

    textAlign: 'left'
}]);

export const lgButtonDisabledSubtitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 300,
    color: '#909090',

    textAlign: 'left'
}]);

export const mdButtonDisabledSubtitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.85rem, 2.5vw, 0.9rem)',
    fontWeight: 300,
    color: '#909090',

    textAlign: 'left'
}]);

export const smButtonDisabledSubtitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.875rem)',
    fontWeight: 300,
    color: '#909090',

    textAlign: 'left'
}]);

//#endregion DISABLED

//#region HIGHLIGHT

const highlight = keyframes({
    '0%': {
        filter: 'blur(0px)'
    },
    '50%': {
        filter: 'blur(5px)',
    },
    '100%': {
        filter: 'blur(0px)',
    }
});

export const buttonContainerHighlightStyles = mergeStyles([{
    position: 'relative',
    width: '100%',
    padding: '1dvh',
    backgroundColor: '#F0F0F0',
    cursor: 'pointer',
    borderRadius: '5px',
    border: '1px solid #ff9900',
    ':before, :after': {
        content: '""',
        position: 'absolute',
        left: '-1px',
        top: '-1px',
        background: '#ff9900',
        backgroundSize: '400%',
        width: 'calc(100% + 2px)',
        height: 'calc(100% + 2px)',
        borderRadius: '5px',
        zIndex: -1,
        animation: `${highlight} 3s infinite`
    },
    ':after': {
        filter: 'blur(15px)'
    },
    ':hover': {
        width: '100%',
        padding: '1dvh',
        cursor: 'pointer',
        borderRadius: '5px',
    }
}]);

//#endregion HIGHLIGHT

//#endregion Dashboard buttons

//#region Provisioning Message

export const provisioningMessageContainerStyles = mergeStyles([{
    width: '70%',
    height: '100%',
    gap: '1dvh',
}]);

export const provisioningMessageImageStyles: IStyleFunctionOrObject<IImageStyleProps, IImageStyles> = {
    image: {
        width: '7rem',
        height: 'auto',
        color: '#a9c963'
    }
};

export const xxlProvisioningMessageImageStyles: IStyleFunctionOrObject<IImageStyleProps, IImageStyles> = {
    image: {
        width: '4rem',
        height: 'auto',
        color: '#a9c963'
    }
};

export const xlProvisioningMessageImageStyles: IStyleFunctionOrObject<IImageStyleProps, IImageStyles> = {
    image: {
        width: '6rem',
        height: 'auto',
        color: '#a9c963'
    }
};

export const lgProvisioningMessageImageStyles: IStyleFunctionOrObject<IImageStyleProps, IImageStyles> = {
    image: {
        width: '5rem',
        height: 'auto',
        color: '#a9c963'
    }
};

export const mdProvisioningMessageImageStyles: IStyleFunctionOrObject<IImageStyleProps, IImageStyles> = {
    image: {
        width: '4rem',
        height: 'auto',
        color: '#a9c963'
    }
};

export const smProvisioningMessageImageStyles: IStyleFunctionOrObject<IImageStyleProps, IImageStyles> = {
    image: {
        width: '3rem',
        height: 'auto',
        color: '#a9c963'
    }
};

//#region TITLE

export const titleProvisioningStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.8rem', // decreased by 10%
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'center'
}]);

export const xxlProvisioningTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(16px, 3dvh, 48px)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'center'
}]);

export const xlProvisioningTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.17rem, 2.25vw, 1.26rem)', // decreased by 10%
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'center'
}]);

export const lgProvisioningTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(1.08rem, 2.25vw, 1.17rem)', // decreased by 10%
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'center'
}]);

export const mdProvisioningTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.99rem, 2.25vw, 1.08rem)', // decreased by 10%
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'center',
    paddingTop: '1dvh',
    paddingBottom: '1dvh',
}]);

export const smProvisioningTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.25vw, 0.99rem)', // decreased by 10%
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'center',
    paddingTop: '1dvh',
    paddingBottom: '1dvh',
}]);

//#endregion TITLE

//#region SUBTITLE

export const subProvisioningTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.1rem', // decreased by 10%
    fontWeight: 300,
    color: '#323130',

    textAlign: 'center'
}]);

export const xxlProvisioningSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(11px, 1.5dvh, 48px)',
    fontWeight: 300,
    color: '#323130',

    textAlign: 'center'
}]);

export const xlProvisioningSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.99rem, 2.25vw, 1.08rem)', // decreased by 10%
    fontWeight: 300,
    color: '#323130',

    textAlign: 'center'
}]);

export const lgProvisioningSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.99rem, 2.25vw, 1.08rem)', // decreased by 10%
    fontWeight: 300,
    color: '#323130',

    textAlign: 'center'
}]);

export const mdProvisioningSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.25vw, 0.99rem)', // decreased by 10%
    fontWeight: 300,
    color: '#323130',

    textAlign: 'center',
    paddingBottom: '1dvh',
}]);

export const smProvisioningSubTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.81rem, 2.25vw, 0.9rem)', // decreased by 10%
    fontWeight: 300,
    color: '#323130',

    textAlign: 'center',
    paddingBottom: '1dvh',
}]);

//#endregion SUBTITLE

//#endregion Provisioning Message